import { Card, Typography } from '@material-ui/core';
import BusinessIcon from '@material-ui/icons/Business';
import LanguageIcon from '@material-ui/icons/Language';
import MailIcon from '@material-ui/icons/Mail';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';
import { useAuth } from 'context/AuthContext';
import { Company } from 'graphql/generated';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CompanySummaryItem } from './company-summary-item';
import { useStyle } from './company-summary.style';
type CompanySummaryProps = {
    company: Company;
};

export const CompanySummary: React.FC<CompanySummaryProps> = ({ company: { website, type, employers } }) => {
    const classes = useStyle();
    const { isAdmin } = useAuth();
    const { t } = useTranslation();
    const employer = employers?.edges[0]?.node;
    return (
        <Card className={classes.container}>
            <Typography className={classes.headline} variant="h5" color="textSecondary">
                {t('companyDetail:companySummary')}
            </Typography>
            <div className={classes.content}>
                <ul>
                    {type && (
                        <CompanySummaryItem
                            title={t(`companyDetail:type`)}
                            text={t(`companyDetail:${type}`)}
                            icon={<BusinessIcon />}
                        />
                    )}
                    {isAdmin && employer && (
                        <>
                            <CompanySummaryItem
                                title={t(`companyDetail:firstName`)}
                                text={employer.firstName || ''}
                                icon={<PersonIcon />}
                            />
                            <CompanySummaryItem
                                title={t(`companyDetail:lastName`)}
                                text={employer.lastName || ''}
                                icon={<PersonIcon />}
                            />
                            <CompanySummaryItem
                                title={t(`companyDetail:email`)}
                                text={employer.user.email}
                                icon={<MailIcon />}
                            />
                            <CompanySummaryItem
                                title={t(`companyDetail:phoneNumber`)}
                                text={employer.phoneNumber}
                                icon={<PhoneIcon />}
                            />
                        </>
                    )}
                    {website && (
                        <CompanySummaryItem
                            title={t(`companyDetail:website`)}
                            link
                            text={website}
                            icon={<LanguageIcon />}
                        />
                    )}
                </ul>
            </div>
        </Card>
    );
};
